/*
 * Methods:
 *
 * initShortlist
 * destroyShortlist
 * checkIfProjectsShortlisted
 * checkIfProductsShortlisted
 * addRemoveProjectFromShortlistEvt
 * addRemoveProductFromShortlistEvt
 * listShortlistedProjects
 * listShortlistedProducts
 * removeAllEvt
 *
 */


var shortlist = {
    checkedForProducts: false, // used on init to fade in container
    checkedForProjects: false, // used on init to fade in container
    hasShortlistedProducts: false, // used on the shortlist page to display border between products/projects
    hasShortlistedProjects: false, // used on the shortlist page to display border between products/projects
    // noListingMsgDisplayed: false, // used on the shortlist page if no listing at all
    shareEl: '.liquid_shortlist_share_form',

    shortlistCounter: function() {
        var _this = this;
        //shortlist counter
        var shortlistedProjects = storageSupported?localStorage.getItem("projects"):_this.readCookie("shortlisted_projects");
        var shortlistedProducts = storageSupported?localStorage.getItem("products"):_this.readCookie("shortlisted_products");
        var cnt_shortlist = (shortlistedProjects?shortlistedProjects.split("-").length:0) + (shortlistedProducts?shortlistedProducts.split("-").length:0);

        // update count
        $(".shortlist_count").html(cnt_shortlist);
        // animate star
        $(".shortlist-link .shortlist-star-container").addClass('active');
        setTimeout(function(){
            $(".shortlist-link .shortlist-star-container").removeClass('active');
        },500)

        // hide/show count
        if(cnt_shortlist < 0 || !cnt_shortlist) {
            // $(".shortlist-link").hide();
            $(".shortlist-item").fadeOut();
        } else {
            // $(".shortlist-link").show();
            $(".shortlist-item").fadeIn();
        }
    },

    writeCookie: function(name, value, exp_days){
        var date = new Date();
        var days = exp_days || 365;
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        window.document.cookie = name + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
    },

    readCookie: function(name){
            var nameEQ = name + "=";
        var ca = window.document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    removeCookie: function(name){
        var _this = this;
        _this.writeCookie(name, "", -1);
    },

    // Init Shortlist listing (module on Shortlist page.)
    initShortlist: function(parsleyOptions) {
        var _this = this;
        // if($("#share_shortlist").length) {
        if($(".shortlist-listings-container").length) {
            _this.listShortlistedProjects();
            _this.listShortlistedProducts();
        }
        
        _this.removeAllEvt();
        _this.checkIfProjectsShortlisted();
        _this.checkIfProductsShortlisted();
        _this.addRemoveProductFromShortlistEvt();
        _this.addRemoveProjectFromShortlistEvt();

        //check if parsley if available, if not initialize it
        if(typeof($(_this.shareEl).parsley()) !== typeof(Function)) {
            $(_this.shareEl).parsley(parsleyOptions);
        }

        $(document).on('submit', _this.shareEl, function (e) {
            e.preventDefault();

            if ($(this).find('button[type="submit"]').hasClass("disabled")) {
                return;
            }

            var form = $(this);
            var formContainer = $(this).parent('.form-container');

            formContainer.find('.form-success-msg').html('').fadeOut();
            
            formContainer.find('.form-error-msg').html('').fadeOut();

            // show spinner
            // form.find(".form-btn .spinner").removeClass('is-hidden');
            form.find(".form-btn").addClass('loading');

            var shortlisted_projects = storageSupported ? localStorage.getItem("projects") : _this.readCookie("shortlisted_projects");
            var shortlisted_products = storageSupported ? localStorage.getItem("products") : _this.readCookie("shortlisted_products");

            var formData = form.serialize() + '&action=process_liquid_share_shortlist_form&projects=' + shortlisted_projects + '&products=' + shortlisted_products;

            var deferred_request = $.ajax({
                method: "POST",
                url: admin_ajax_url,
                data: formData,
                datatype: "JSON"
            });

            deferred_request.done(function (data) {

                data = $.parseJSON(data);

                // hide spinner
                //form.find(".form-btn .spinner").addClass('is-hidden');
                form.find(".form-btn").removeClass('loading');

                if (data.success) {
                    // form.hide();
                    form.addClass('off');
                    formContainer.find('.form-success-msg').html(data.message).fadeIn();
                    formContainer.find('.form-error-msg').fadeOut();
                    $("#shortlist_modal .content .lead").hide();
                } else {
                    formContainer.find('.form-error-msg').html(data.message).fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();
                }
            });

            deferred_request.fail(function (data) {
                console.log('Failed AJAX Call :( /// Return Data: ' + data);

                form.find(".form-btn").removeClass('loading');
                formContainer.find('.form-error-msg').html('<p>Something went wrong. Please try again later.</p>').fadeIn();
                formContainer.find('.form-success-msg').fadeOut();


            });
        });

        $("#shortlist_modal").on('hide.bs.modal', function(){
            if ( $(_this.shareEl).length > 0 ) {
                $(_this.shareEl).parsley().reset();
            }
        });


        // $(".modal-close").on('click', function (e) {
        //     $(_this.shareEl).parsley().reset();
        // });

        // === CLOSE SHORTLIST MODAL ON CLICK ON OVERLAY
        $("#shortlist_modal").on('click', function (e) {
            var modal = $(this);
            if ( $(e.target).hasClass('modal-dialog') || $(e.target).hasClass('modal-overlay') ) {
                modal.find('.modal-close').trigger('click');
            }
        });



        _this.shortlistCounter();
    },
    // Init Shortlist listing
    destroyShortlist: function() {
        var _this = this;
        $(document).off('submit', _this.enquiryEl);
    },

    // Update project listing
    listShortlistedProjects: function() {
        var _this = this;
        var shortlisted = storageSupported ? localStorage.getItem("projects") : _this.readCookie("shortlisted_projects");
        var formData = 'action=get_projects_by_ids&shortlisted=' + shortlisted +'&animatestar=false';

        var deferred_request = $.ajax({
            method: "POST",
            url: admin_ajax_url,
            data: formData,
            datatype: "JSON"
        });

        deferred_request.done(function (data) {

            data = $.parseJSON(data);

            _this.checkedForProjects = true;
            
            // 2 ajax calls done (product and project)
            if ( _this.checkedForProducts && $('.shortlist-listings-container').length > 0 ) {
                $('.shortlist-listings-container').removeClass('loading');
            }

            // show results

            var markup = [
                '<section class="available-space-section">',
                '<div class="empty-space medium-spacer"></div>',
                '<div class="heading">',
                    '<div class="row-flex">',
                        '<div class="flex-col">',
                            '<h2><b>Shortlisted</b><br>Projects</h2>',
                        '</div>',

                        '<div class="flex-col col-link"></div>',
                    '</div>',
                '</div>',
                '<div class="section-body">'+data.html+'</div>',
                '<div class="empty-space medium-spacer"></div>',
            '</section>',
            ].join('');

        
            // show "remove all" link
            if ( data.projects.length > 0 ) {

                _this.hasShortlistedProjects = true;

                // add border between them
                if ( _this.hasShortlistedProducts ) {
                    $("#shortlisted_products").addClass('has-border');
                } else {
                    $("#shortlisted_products").removeClass('has-border');
                }

                $("#shortlisted_products").removeClass('is-last-one');

                // update markup
                // $("#shortlisted_projects").find('.section-body').html(data.html); 
                $("#shortlisted_projects").find('.main-wrapper').html(markup); 

                // show "remove all" link
                var link = '<span id="removeAllProjects" class="reset-link has-icon right-icon"><span class="text">Remove All Projects</span>'+close_icon+'</span>';
                $("#shortlisted_projects").find('.col-link').html(link); 

                // 2 ajax calls are done
                if ( _this.checkedForProducts && $('.shortlist-listings-container').length > 0 ) {
                    _this.handeEmptyShortlist();
                }
                
                searchMap.initItemSlider($("#shortlisted_projects").find('.item'));
                
                var i = 0;
                var shortlisting_project_ids = "";
                storageSupported ? localStorage.removeItem("projects") : _this.removeCookie("shortlisted_projects");//remove all shortlisted projects
                data.projects.forEach(function(project){
                    if(i<1) {
                        shortlisting_project_ids += ":"+project.ID+":";
                    } else {
                        shortlisting_project_ids += "-:"+project.ID+":";
                    }
                    i++;
                });
                storageSupported?localStorage.setItem("projects", shortlisting_project_ids):_this.writeCookie("shortlisted_projects", shortlisting_project_ids);
           
            } else {
                storageSupported ? localStorage.removeItem("projects") : _this.removeCookie("shortlisted_projects");//remove all shortlisted projects
                _this.hasShortlistedProjects = false;
                $("#shortlisted_products").removeClass('has-border');
                $("#shortlisted_products").addClass('is-last-one');

                 _this.handeEmptyShortlist();

                // fade out section
                // if ( _this.hasShortlistedProducts ) {
                    $("#shortlisted_projects").fadeOut();
                // } 

            }

            $('[data-toggle="tooltip"]').tooltip();
            _this.shortlistCounter();
            _this.removeAllEvt();
        });

        deferred_request.fail(function (data) {
            console.log("error (listShortlistedProjects)");
        });
    },
    // Update product listing
    listShortlistedProducts:  function() {
        var _this = this;
        var shortlisted = storageSupported ? localStorage.getItem("products") : _this.readCookie("shortlisted_products");
        var formData = 'action=get_products_by_ids&shortlisted=' + shortlisted +'&animatestar=false';

        var deferred_request = $.ajax({
            method: "POST",
            url: admin_ajax_url,
            data: formData,
            datatype: "JSON"
        });

        deferred_request.done(function (data) {

            data = $.parseJSON(data);

            _this.checkedForProducts = true;
            
            // 2 ajax calls are done.
            if ( _this.checkedForProjects && $('.shortlist-listings-container').length > 0 ) {
                $('.shortlist-listings-container').removeClass('loading');
            }

            // show results

            var markup = [
                '<section class="available-space-section">',
                '<div class="empty-space medium-spacer"></div>',
                '<div class="heading">',
                    '<div class="row-flex">',
                        '<div class="flex-col">',
                            '<h2><b>Shortlisted</b><br>Spaces</h2>',
                        '</div>',

                        '<div class="flex-col col-link"></div>',
                    '</div>',
                '</div>',
                '<div class="section-body">'+data.html+'</div>',
                '<div class="empty-space medium-spacer"></div>',
            '</section>',
            ].join('');


            // show "remove all" link
            if ( data.products.length > 0 ) {
                _this.hasShortlistedProducts = true;
                if ( _this.hasShortlistedProjects ) {
                    $("#shortlisted_products").addClass('has-border');
                } else {
                    $("#shortlisted_products").removeClass('has-border');
                }
                // $("#shortlisted_products").find('.section-body').html(data.html);
                $("#shortlisted_products").find('.main-wrapper').html(markup); 

                var link = '<span id="removeAllProducts" class="reset-link has-icon right-icon"><span class="text">Remove All Spaces</span>'+close_icon+'</span>';
                $("#shortlisted_products").find('.col-link').html(link); 

                // 2 ajax calls are done.
                if ( _this.checkedForProjects && $('.shortlist-listings-container').length > 0 ) {

                    _this.handeEmptyShortlist();
                }
                searchMap.initItemSlider($("#shortlisted_products").find('.item'));
                
                var i = 0;
                var shortlisting_product_ids = "";
                storageSupported ? localStorage.removeItem("products") : _this.removeCookie("shortlisted_products");//remove all shortlisted products
                data.products.forEach(function(product){
                    if(i<1) {
                        shortlisting_product_ids += ":"+product.ID+":";
                    } else {
                        shortlisting_product_ids += "-:"+product.ID+":";
                    }
                    i++;
                });
                storageSupported?localStorage.setItem("products", shortlisting_product_ids):_this.writeCookie("shortlisted_products", shortlisting_product_ids);

            } else {
                storageSupported ? localStorage.removeItem("products") : _this.removeCookie("shortlisted_products");//remove all shortlisted products
                _this.hasShortlistedProducts = false;
                $("#shortlisted_products").removeClass('has-border');
                
                // fade out section
                $("#shortlisted_products").fadeOut();

                 _this.handeEmptyShortlist();


                // // fade out section
                // if ( _this.hasShortlistedProjects ) {
                //     $("#shortlisted_products").fadeOut();
                // } 
                // // if nothing in the shortlist, display a message.
                // else {
                //     $("#shortlisted_products").find('.main-wrapper').html('<p>Nothing in your shortlist.</p>'); 
                // }
            }

            $('[data-toggle="tooltip"]').tooltip();

            _this.shortlistCounter();
            _this.removeAllEvt();
            lazyload.init();
        });

        deferred_request.fail(function (data) {
            console.log("error (listShortlistedProducts)");
        });

    },
    // Update star on project cards
    checkIfProjectsShortlisted: function() {
        var _this = this;
        //check if projects are shortlisted
        $('.addprojecttoshortlist').each(function(i, el) {
            var projectId = el.getAttribute('data-projectid');
            var currentProjects = storageSupported?localStorage.getItem("projects"):_this.readCookie("shortlisted_projects");
            if(currentProjects) {
                // this project is shortlisted
                if (currentProjects.indexOf(":" + projectId + ":") !== -1) {
                    _this.updateStarToRemove($(el), 'project');
                } 
                // this project is not shortlisted
                else {
                    _this.updateStarToAdd($(el), 'project');
                }
            } 
            // no project shortlisted
            else {
                _this.updateStarToAdd($(el), 'project');
            }
        });
    },
    // Update star on product cards
    checkIfProductsShortlisted: function() {
        var _this = this;
        $('.addproducttoshortlist').each(function(i, el) {
            var productId = el.getAttribute('data-productid');
            var currentProducts = storageSupported?localStorage.getItem("products"):_this.readCookie("shortlisted_products");

            if(currentProducts) {
                // this product is shortlisted
                if (currentProducts.indexOf(":" + productId + ":") !== -1) {
                    _this.updateStarToRemove($(el), 'product');
                }
                // this project is not shortlisted
                else {
                    _this.updateStarToAdd($(el), 'product');
                }
            } 
            // no project shortlisted
            else {
                _this.updateStarToAdd($(el), 'product');
            }
        });
    },
    // Handle click on project star
    addRemoveProjectFromShortlistEvt: function() {
        var _this = this;
        //$('.addprojecttoshortlist').off();
        $(document).off('click', '.addprojecttoshortlist');
        $(document).on('click', '.addprojecttoshortlist', function (e) {
            e.stopPropagation();
            
            // Click on "remove project from shortlist"
            if($(this).hasClass('removeprojectfromshortlist')) {
                var projectId = this.getAttribute('data-projectid');

                var currentProjects = storageSupported?localStorage.getItem("projects"):_this.readCookie("shortlisted_projects");
                
                // ...
                if (currentProjects) {
                    currentProjects = currentProjects.replace(":" + projectId + ":-", "");
                    
                    if (currentProjects) {
                        currentProjects = currentProjects.replace("-:" + projectId + ":", "");
                        
                        if (currentProjects) {
                            currentProjects = currentProjects.replace(":" + projectId + ":", "");
                            
                        }
                    }
                }
                
                // Remove project from shortlist
                if(currentProjects) {
                    storageSupported?localStorage.setItem("projects", currentProjects):_this.writeCookie("shortlisted_projects", currentProjects);
                } else {
                    storageSupported?localStorage.removeItem("projects"):_this.removeCookie("shortlisted_projects");
                }
                
                // update star to be "add to shortlist"
                _this.updateStarToAdd($(this), 'project');
                

                // On shortlist page: fade out item
                if ( $(this).parents('.shortlist-listings-container').length > 0) {
                    var card = $(this).parents('.item');
                    _this.fadeOutFromShortlist(card,'project');
                }
                    
                // if(typeof(_this.listShortlistedProjects) == "function") {
                //     _this.listShortlistedProjects();
                // }

            } 

            // Click on "add project to shortlist"
            else {
                var projectId = this.getAttribute('data-projectid');
                var currentProjects = storageSupported?localStorage.getItem("projects"):_this.readCookie("shortlisted_projects");
                var projects = null;

                // Add project to the list of already shortlisted projects
                if (currentProjects) {
                    if (currentProjects.indexOf(":" + projectId + ":") === -1) {
                        projects = currentProjects + "-:" + projectId + ":";
                    }
                } 
                // This project is the first shortlisted
                else {
                    projects = ":" + projectId + ":";
                }

                // Save project to shortlist
                if(projects) {
                    //storageSupported?localStorage.removeItem("projects"):_this.removeCookie("shortlisted_projects");
                    storageSupported?localStorage.setItem("projects", projects):_this.writeCookie("shortlisted_projects", projects);
                }
                
                // update star to be "remove from shortlist"
                _this.updateStarToRemove($(this), 'project');
            }

            // ?
            _this.shortlistCounter();

            // ...
            _this.checkIfProjectsShortlisted();
        });

    },
    // Handle click on product star
    addRemoveProductFromShortlistEvt: function() {
        var _this = this;
        //$('.addproducttoshortlist').off(); 
        $(document).off('click', '.addproducttoshortlist');
        $(document).on('click', '.addproducttoshortlist', function (e) {

            e.stopPropagation();

            // Click on "Remove product from shortlist"
            if($(this).hasClass('removeproductfromshortlist')) {

                var productId = this.getAttribute('data-productid');
                var currentProducts = storageSupported?localStorage.getItem("products"):_this.readCookie("shortlisted_products");

                if (currentProducts) {
                    currentProducts = currentProducts.replace(":" + productId + ":-", "");

                    if (currentProducts) {
                        currentProducts = currentProducts.replace("-:" + productId + ":", "");
    
                        if (currentProducts) {
                            currentProducts = currentProducts.replace(":" + productId + ":", "");
        
                        }
                    }
                }
                
                // Remove project from shortlist
                if(currentProducts) {
                    storageSupported?localStorage.setItem("products", currentProducts):_this.writeCookie("shortlisted_products", currentProducts);
                } else {
                    storageSupported?localStorage.removeItem("products"):_this.removeCookie("shortlisted_products");
                }

                // Update star to be "add to shortlist"
                _this.updateStarToAdd($(this), 'product');


                // On shortlist page: fade out item
                if ( $(this).parents('.shortlist-listings-container').length > 0 ) {
                    var card = $(this).parents('.item');
                    _this.fadeOutFromShortlist(card,'product');
                }


                // Update listing
                // if(typeof(_this.listShortlistedProducts) == "function") {
                //     _this.listShortlistedProducts();
                // }
            } 

            // Click on "Add product to shortlist"
            else {
                var productId = this.getAttribute('data-productid');
                var currentProducts = storageSupported?localStorage.getItem("products"):_this.readCookie("shortlisted_products");
                var products = null;

                // Add product to the list of already shortlisted products
                if (currentProducts) {
                    if (currentProducts.indexOf(":" + productId + ":") === -1) { 
                        products = currentProducts + "-:" + productId + ":";
                    }
                } 
                // This product is the first shortlisted
                else {
                    products = ":" + productId + ":";
                }

                // Save to shortlist
                if(products) {
                    storageSupported?localStorage.setItem("products", products):_this.writeCookie("shortlisted_products", products);
                }

                // update star to be "remove from shortlist"
                _this.updateStarToRemove($(this), 'product');
            }

            _this.shortlistCounter();
            _this.checkIfProductsShortlisted();
        });
    },
    // Handle click on "Remove All" links
    removeAllEvt: function() {
        var _this = this;
        if($("#removeAllProjects").length) {
            //$('#removeAllProjects').off();
            $(document).off('click', '#removeAllProjects');
            $(document).on('click', '#removeAllProjects', function (event) {
                storageSupported ? localStorage.removeItem("projects") : _this.removeCookie("shortlisted_projects");
                _this.listShortlistedProjects();
            }); 
        }

        if($("#removeAllProducts").length) {
            //$('#removeAllProducts').off();
            $(document).off('click', '#removeAllProducts');
            $(document).on('click', '#removeAllProducts', function (event) {
                storageSupported ? localStorage.removeItem("products") : _this.removeCookie("shortlisted_products");
                _this.listShortlistedProducts();
            });
        }
    },
    // update star style for both products and projects
    updateStarToAdd: function(starEl, listingType) {
        var _this = this;
        // tooltip_shortlist_add saved in helpers.js

        if ( listingType && listingType == 'product') {
            starEl.removeClass('removeproductfromshortlist');
        } else if ( listingType && listingType == 'project' ) {
            starEl.removeClass('removeprojectfromshortlist');
        } else {
            console.log('Error: updateStarToAdd listingType incorrect')
        }

        starEl.removeClass('active');
        starEl.attr('title', tooltip_shortlist_add);
        starEl.tooltip('hide');
        starEl.attr('data-original-title', tooltip_shortlist_add);

        if(starEl.hasClass('sidebar') || starEl.hasClass('fixnav')) {
            if ( starEl.attr('href') == '/shortlist' ) { return; }
            // starEl.html('<i class="icon-empty-star"></i>Add to Shortlist');
            starEl.attr('href', 'javascript:;');
            starEl.find('.shortlist-star-container').removeClass('active');
            starEl.find('.text').html('Add to Shortlist');
        }

    },
    // update star style for both products and projects
    updateStarToRemove: function(starEl, listingType) {
        var _this = this;

        // tooltip_shortlist_remove saved in helpers.js

        if ( listingType && listingType == 'product') {
            starEl.addClass('removeproductfromshortlist');
        } else if ( listingType && listingType == 'project' ) {
            starEl.addClass('removeprojectfromshortlist');
        } else {
            console.log('Error: updateStarToRemove listingType incorrect')
        }

        starEl.addClass('removeprojectfromshortlist active');
        // starEl.addClass('active');
        starEl.attr('title', tooltip_shortlist_remove);
        starEl.tooltip('hide');
        starEl.attr('data-original-title', tooltip_shortlist_remove);

        if(starEl.hasClass('sidebar') || starEl.hasClass('fixnav') ) {
            //starEl.html('<i class="icon-star"></i>Remove from Shortlist');
            // starEl.html('<a href="/shortlist">Added - view shortlist</a>');
            // without timeout the page is redirected to shortlist
            setTimeout(function(){
                starEl.attr('href', '/shortlist');
            }, 100)
            // starEl.attr('href', '/shortlist');
            starEl.find('.shortlist-star-container').addClass('active');
            starEl.find('.text').html('Added - view shortlist');
            starEl.attr('title', 'View shortlist');
        }
    },

    fadeOutFromShortlist: function(item, listingType) {
        var _this = this;
        // var item = $(this).parents('.item');
        item.addClass('fadingOut');

        setTimeout(function(){
            item.animate({
                width: 0,
                minWidth: 0,
                // maxWidth: 0,
            }, 400);
        }, 400);

        // TODO: dont animate star on item load.

        // update section (if no more items fade out section)
        if ( listingType && listingType == 'product') {
            _this.listShortlistedProducts();
        } else if ( listingType && listingType == 'project' ) {
            _this.listShortlistedProjects();
        } else {
            console.log('Error: fadeOutFromShortlist listingType incorrect')
        }
    },

    handeEmptyShortlist: function() {
        var _this = this;

        // no listing found
        if ( !_this.hasShortlistedProducts && !_this.hasShortlistedProjects ) {
            $('.shortlist-listings-container').find('.no-listing-msg').html('<p>Your shortlist is empty.</p>'); 
        } else {
            $('.shortlist-listings-container').find('.no-listing-msg').html('');   
        }
    },
    // item can be card or popup.
    initItemSlider: function(item) {

      item.each(function(){
        var el = $(this);

        // var container = el.find('.img-wrapper');
        var container = el.find('.listing-item-slider');
        var slider = container.find('.slider');

        if (container === undefined || container.length < 1) return;

        slider.slick({
          infinite: true,
          autoplay:false,
          fade: true,
          speed: 300,
          dots: false,
          arrows: true,
          appendArrows: container,
          prevArrow: '<button type="button" class="slider-prev btn-style-none" alt="Previous Slide">'+arrow_left+'</button>',
          nextArrow: '<button type="button" class="slider-next btn-style-none" alt="Next Slide">'+arrow_right+'</button>',
          draggable: true,
          rows: 0
        });

      })


    },
}



